export const content = {
  title: "Our Team",
  subtitle: "Meet our pilot experts who are here to help our clients through their training.",
  teamMembers: [
    {
      image: {
        url: "./assets/ourTeamImages/teamMember-tarik.jpg",
        alt: "Merryface",
      },
      name: "Tarik (Merryface)",
      bio: "Tarik is an EASA rated flight instructor, business jet pilot, and former A320 airline pilot. Tarik has professional experience as a flight instructor, survey pilot, and an airline pilot for a major European carrier. Tarik has been using flight simulators to help his training since 2007 and he hasn’t stopped using them since.",
    },
    {
      image: {
        url: "./assets/ourTeamImages/teamMember-kushal.jpg",
        alt: "Kainine",
      },
      name: "Kushal (Kainine)",
      bio: "Kushal’s commercial experience started early on, gettting onto the Dash 8 Q-400 as a First Officer, before moving onto the Airbus A320. With over 3000 hours of flight experience, and a long-lasting passion for flight simulation, Kushal has always been passionate about flying and has a wealth of knowledge to share.",
    },
    {
      image: {
        url: "./assets/ourTeamImages/teamMember-andrew.jpg",
        alt: "Puffmac",
      },
      name: "Andrew (Puffmac)",
      bio: "Not only is Andrew an airline pilot on the ATR, he also has had years of experience teaching and coaching people in his career as well as carrying out discovery flights for newcomers to aviation. Andrew is our in-house groundschool expert, and is exceptionally skilled at running engaging lessons.",
    },
  ]
}